import React from "react";
import { Select } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { SelectOption } from "../../../../components/form";
import { DEFAULTS, ORDER_STATUSES } from "./constants";

interface OrderStatusProps {
    orderStatus: number;
    setState: any;
}

export const OrderStatus = (props: OrderStatusProps): JSX.Element => {
    const intl = useIntl();

    const orderStatuses: SelectOption[] = [
        { value: ORDER_STATUSES.ACCEPTED, label: intl.formatMessage({ id: "store_accepted" }) },
        { value: ORDER_STATUSES.PREPARING, label: intl.formatMessage({ id: "store_is_preparing" }) },
    ];

    return (
        <div className="white-single-block">
            <div className="d-flex w100 flex-column justify-content-start align-items-start">
                <div className="option-title" style={{ marginBottom: "10px" }}>
                    <FormattedMessage id="auto_accept_order_status" />
                </div>
                <Select
                    className="surTax-field"
                    value={props.orderStatus ?? DEFAULTS.ORDER_STATUS}
                    onChange={(val) => props.setState("order_status", val)}
                >
                    {orderStatuses.map((option: SelectOption) => (
                        <Select.Option key={option.value} value={option.value}>
                            {option.label}
                        </Select.Option>
                    ))}
                </Select>
            </div>
        </div>
    );
};
